<template>
  <div class="header-auth">
    <div v-if="isAuthorize" class="header-auth__workspace tooltip-assist">
      <a
        v-if="isAuthorize && otherVerticalSubs.financial_services && otherVerticalSubs.financial_services.active"
        class="header-auth__financial"
        :href="fsUrl"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160"><path d="M8 40h2c1.24 1.502 2.48 3.006 3.691 4.531C15.255 46.287 16.803 47.186 19 48c-.53 3.92-1.427 7.638-2.5 11.438-4.794 17.327-2.156 33.326 6.406 48.964C30.636 121.9 42.324 130.791 57 136c15.257 4.098 29.193 3.954 44-2h3c1.535 1.645 1.535 1.645 3.063 3.813l1.535 2.144A448.833 448.833 0 01112 145c-16.655 9.517-37.555 10.896-56.063 6.5-20.52-6.64-37.025-18.794-47.746-37.688C6.607 110.588 5.261 107.364 4 104l-1.25-3.273C-3.717 80.743-1.152 58.63 8 40zM121.807 13.231C134.35 22.431 143.53 34.403 149 49l1.25 3.273c6.295 19.453 3.844 40.312-4.25 58.727-3.444-1.53-6.095-3.617-9-6l-3-2 .586-2.02c5.739-20.312 5.84-37.513-4.492-56.382C122.364 31.1 110.676 22.209 96 17c-12.607-3.386-22.782-3.477-35.45-.754A185.218 185.218 0 0151 18l-1.242-1.715-1.633-2.222-1.617-2.215C45.12 9.889 45.12 9.889 43 9l1-3a73.048 73.048 0 017.25-2.625l2.027-.656c22.982-7.315 48.725-2.987 68.53 10.512z" fill="#262053"/><path d="M131 113c3.406 2.147 5.81 4.104 7 8 .425 5.36.477 8.654-3 13-2.884 2.99-5.859 3.699-9.977 4.059-3.346-.097-5.313-1.15-8.023-3.059-3.427-3.878-4.674-6.967-4.383-12.043.906-4.631 3.384-7.253 7.133-9.894 4.104-1.342 7.13-1.32 11.25-.063z" fill="#2D2758"/><path d="M34 15c3.923 2.319 6.55 4.647 8 9 .372 5.02.137 7.997-3 12-2.96 3.22-5.154 4.291-9.438 4.5-4.475-.209-7.154-1.507-10.562-4.5-2.58-4.215-2.55-8.188-2-13 1.3-3.148 2.551-4.617 5.125-6.813C26.189 14.51 29.676 14.07 34 15z" fill="#262053"/></svg>
        <p>Financial Services</p>
      </a>
      <template v-else>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160"><path d="M8 40h2c1.24 1.502 2.48 3.006 3.691 4.531C15.255 46.287 16.803 47.186 19 48c-.53 3.92-1.427 7.638-2.5 11.438-4.794 17.327-2.156 33.326 6.406 48.964C30.636 121.9 42.324 130.791 57 136c15.257 4.098 29.193 3.954 44-2h3c1.535 1.645 1.535 1.645 3.063 3.813l1.535 2.144A448.833 448.833 0 01112 145c-16.655 9.517-37.555 10.896-56.063 6.5-20.52-6.64-37.025-18.794-47.746-37.688C6.607 110.588 5.261 107.364 4 104l-1.25-3.273C-3.717 80.743-1.152 58.63 8 40zM121.807 13.231C134.35 22.431 143.53 34.403 149 49l1.25 3.273c6.295 19.453 3.844 40.312-4.25 58.727-3.444-1.53-6.095-3.617-9-6l-3-2 .586-2.02c5.739-20.312 5.84-37.513-4.492-56.382C122.364 31.1 110.676 22.209 96 17c-12.607-3.386-22.782-3.477-35.45-.754A185.218 185.218 0 0151 18l-1.242-1.715-1.633-2.222-1.617-2.215C45.12 9.889 45.12 9.889 43 9l1-3a73.048 73.048 0 017.25-2.625l2.027-.656c22.982-7.315 48.725-2.987 68.53 10.512z" fill="#262053"/><path d="M131 113c3.406 2.147 5.81 4.104 7 8 .425 5.36.477 8.654-3 13-2.884 2.99-5.859 3.699-9.977 4.059-3.346-.097-5.313-1.15-8.023-3.059-3.427-3.878-4.674-6.967-4.383-12.043.906-4.631 3.384-7.253 7.133-9.894 4.104-1.342 7.13-1.32 11.25-.063z" fill="#2D2758"/><path d="M34 15c3.923 2.319 6.55 4.647 8 9 .372 5.02.137 7.997-3 12-2.96 3.22-5.154 4.291-9.438 4.5-4.475-.209-7.154-1.507-10.562-4.5-2.58-4.215-2.55-8.188-2-13 1.3-3.148 2.551-4.617 5.125-6.813C26.189 14.51 29.676 14.07 34 15z" fill="#262053"/></svg>
          <p class="header-auth__disabled">Financial Services</p>
          <Tooltip :size="'small'" class="tip"><p>Email <a href="mailto:clientvalue@vixio.com">clientvalue@vixio.com</a> to activate this feature</p></Tooltip>
      </template>
    </div>
    <div v-if="isAuthorize" class="header-auth__workspace tooltip-assist"
         >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc. --><path d="M64 48C37.5 48 16 69.5 16 96l0 320c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48L64 48zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM325.7 197.7l-128 128c-3.1 3.1-8.2 3.1-11.3 0l-64-64c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L192 308.7 314.3 186.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z"/></svg>
      <p
        v-if="workspaceAccess"
        @click="handleWorkspace"
      >VIXIO WORKSPACE
      </p>
      <template v-else>
        <p class="header-auth__disabled">VIXIO WORKSPACE</p>
        <Tooltip :size="'small'" class="tip" />
      </template>
    </div>
    <div v-if="isAuthorize" class="header-auth__mytools" @mouseleave="isMyToolsDropdown = false" @mouseover="isMyToolsDropdown = true">
      <div class="header-auth__title mytools" >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24.239"
          height="18.075"
          viewBox="0 0 24.239 18.075"
        >
          <path
            id="Icon:_Tools"
            d="M265.015,252.252l-.372-1.493a2.1,2.1,0,0,0-2.039-1.591h-.819a.56.56,0,1,0,0,1.12h.819a.981.981,0,0,1,.952.743l.3,1.219.233,1.121h.7v.6a.211.211,0,0,1-.213.211h-7.914v-.806l-.013-1.121a.934.934,0,0,0-.918-.77H251.85a.931.931,0,0,0-.913.77l-.02,1.121v.806H243a.21.21,0,0,1-.211-.211v-.6h.661l.266-1.121.305-1.219a.979.979,0,0,1,.951-.743h14.631a.56.56,0,0,0,0-1.12h-.632v-2.549a1.307,1.307,0,0,0-1.3-1.3H249.91a1.306,1.306,0,0,0-1.3,1.3v2.549h-3.631a2.1,2.1,0,0,0-2.039,1.592l-.373,1.492a.947.947,0,0,0-.893.944v.77a1.341,1.341,0,0,0,.811,1.225l.6,6.295a2.093,2.093,0,0,0,2.092,1.9h4.378a.946.946,0,0,0,.924-.771H257.1a.948.948,0,0,0,.93.771h4.378a2.094,2.094,0,0,0,2.092-1.9l.6-6.295a1.341,1.341,0,0,0,.811-1.225v-.77A.947.947,0,0,0,265.015,252.252Zm-9.11-3.084h-4.3v-1.192h4.3Zm-6.18-2.549a.184.184,0,0,1,.184-.184h7.759a.184.184,0,0,1,.184.184v2.549h-.973l0-2.112h-6.234l-.014,2.112h-.9Zm-.349,15.649h-4.2a.977.977,0,0,1-.977-.887l-.579-6.083h5.76Zm2.662-9.668h3.5v1.111h-3.5Zm0,2.232h3.5v1.858a.183.183,0,0,1-.184.184h-3.136a.184.184,0,0,1-.184-.184Zm5.045,6.665H250.5v-6.2h.421v1.393a1.306,1.306,0,0,0,1.3,1.3h3.136a1.306,1.306,0,0,0,1.3-1.3V255.3h.421Zm6.3-.117a.977.977,0,0,1-.977.887h-4.2V255.3h5.758Z"
            transform="translate(-241.67 -245.314)"
            fill="#003865"
          />
        </svg>
        <p>My Tools</p>
        <!-- <span class="new-icon parent">New</span> -->
      </div>
      <div v-if="isMyToolsDropdown" class="header-auth__dropdown">
        <ul>
          <li>
            <nuxt-link v-if="hasAccessTools" to="/reportbuilder">
              Report Builder
            </nuxt-link>
            <template v-else>
              <span class="header-auth__disabled">Report Builder</span>
              <Tooltip :size="'small'" class="tip" />
            </template>
            <!-- <span class="new-icon menu-new">New</span> -->
          </li>
          <li>
            <nuxt-link v-if="hasAccessTools" to="/reportbuilder-us">
              Report Builder (US)
            </nuxt-link>
            <template v-else>
              <span class="header-auth__disabled">Report Builder (US)</span>
              <Tooltip :size="'small'" class="tip" />
            </template>
            <!-- <span class="new-icon menu-new">New</span> -->
          </li>
        </ul>
      </div>
    </div>
    <div v-if="isAuthorize" class="header-auth__profile" @mouseleave="isDropdown = false" @mouseover="isDropdown = true">
      <div class="header-auth__title profile" @click="isDropdown = true">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
        >
          <path
            id="Icon:_Profile"
            data-name="Icon: Profile"
            class="cls-1"
            fill="#003865"
            d="M16.572,11.426a8.431,8.431,0,0,0-2.15-1.346.7.7,0,1,0-.571,1.285,7.031,7.031,0,0,1,1.793,1.117,2.8,2.8,0,0,1,.95,2.107v1.3a.7.7,0,0,1-.7.7H2.109a.7.7,0,0,1-.7-.7v-1.3a2.8,2.8,0,0,1,.95-2.107c.71-.624,2.78-2.076,6.644-2.076a5.209,5.209,0,1,0-3.169-1.08,9.775,9.775,0,0,0-4.4,2.1A4.21,4.21,0,0,0,0,14.59v1.3A2.112,2.112,0,0,0,2.109,18H15.891A2.112,2.112,0,0,0,18,15.891v-1.3A4.21,4.21,0,0,0,16.572,11.426ZM5.2,5.2A3.8,3.8,0,1,1,9,9,3.8,3.8,0,0,1,5.2,5.2Z"
          />
        </svg>
        <p>
          {{ profileMenu.title }}
        </p>
      </div>
      <div v-if="isDropdown" class="header-auth__dropdown">
        <ul>
          <li v-for="(item, index) in profileMenu.submenu" :key="index">
            <nuxt-link
              v-if="
                !item.toolsAccessRequired ||
                (item.toolsAccessRequired && hasAccessTools)
              "
              :to="item.link"
            >
              {{ item.title }}
            </nuxt-link>
          </li>
        </ul>
      </div>
    </div>
    <button
      v-if="isAuthorize"
      class="header-auth__logout"
      @click="handleLogout"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.83"
        height="19"
        viewBox="0 0 16.83 19"
      >
        <g transform="translate(-35.861 0.501)">
          <path
            fill="#003865"
            d="M47.354,66.878a.63.63,0,0,0-.816.355h0a.633.633,0,0,0,.356.817,7.155,7.155,0,1,1-5.236,0,.63.63,0,0,0,.021-1.164.624.624,0,0,0-.481-.008,8.415,8.415,0,1,0,6.157,0Z"
            transform="translate(0 -64.626)"
          />
          <path
            fill="#003865"
            d="M229.225,11.583a.7.7,0,0,0,.7-.7V.2a.7.7,0,1,0-1.406,0V10.88A.7.7,0,0,0,229.225,11.583Z"
            transform="translate(-184.909)"
          />
        </g>
      </svg>
      <p>LOGOUT</p>
    </button>
    <nuxt-link v-else to="/login" class="header-auth__logout">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
      >
        <path
          id="Icon:_Profile"
          data-name="Icon: Profile"
          class="cls-1"
          fill="#003865"
          d="M16.572,11.426a8.431,8.431,0,0,0-2.15-1.346.7.7,0,1,0-.571,1.285,7.031,7.031,0,0,1,1.793,1.117,2.8,2.8,0,0,1,.95,2.107v1.3a.7.7,0,0,1-.7.7H2.109a.7.7,0,0,1-.7-.7v-1.3a2.8,2.8,0,0,1,.95-2.107c.71-.624,2.78-2.076,6.644-2.076a5.209,5.209,0,1,0-3.169-1.08,9.775,9.775,0,0,0-4.4,2.1A4.21,4.21,0,0,0,0,14.59v1.3A2.112,2.112,0,0,0,2.109,18H15.891A2.112,2.112,0,0,0,18,15.891v-1.3A4.21,4.21,0,0,0,16.572,11.426ZM5.2,5.2A3.8,3.8,0,1,1,9,9,3.8,3.8,0,0,1,5.2,5.2Z"
        />
      </svg>
      <p>LOGIN</p>
    </nuxt-link>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import logout from "../../utils/logout";
import { checkAccess } from "@/utils/constants";

export default {
  name: "HeaderAuth",
  components: {
    Tooltip: () => import("../elements/Tooltip"),
  },
  props: {
    profileMenu: {
      type: Object,
      default: null,
    },
    reportsMenu: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isDropdown: false,
      isMyToolsDropdown: false,
      isDropdownReports: false,
      notSubscribeEurope: false,
      notSubscribeAmerica: false,
    };
  },
  async fetch() {
    // If otherVerticalSubs is not null or an empty object, do not fetch again
    const otherVerticalSubs = this.$store.state.Verticals.otherVerticalSubs;
    if (otherVerticalSubs && Object.keys(otherVerticalSubs).length > 0) {
      return;
    }
    await this.$store.dispatch("Verticals/getOtherVerticalSubs", { vertical: "financial_services" });
  },
  computed: {
    ...mapState("Auth", ["isAuthorize", "subscriptions"]),
    ...mapState("Profile", ["userAccess", "dataUser"]),
    ...mapState("Verticals", ["otherVerticalSubs"]),
    ...mapGetters("Auth", ["workspaceAccess"]),

    hasAccessTools(state) {
      if (
        state.subscriptions.legacy_permissions !== null &&
        state.subscriptions.legacy_permissions.length > 0
      )
      return true;

      return checkAccess(state.subscriptions.permissions, "tool");
    },
    fsUrl: function () {
      return this.$config.financialServicesFEURL
        ? this.$config.financialServicesFEURL
        : "https://fs.vixio.com/";
    },
  },
  mounted() {
    if(this.$churnZero && this.dataUser && this.dataUser.salesforceId && this.dataUser.companySfId) {
      this.$churnZero.setContact(this.dataUser.companySfId, this.dataUser.salesforceId);
    }
  },
  methods: {

    handleLogout() {
      this.$router.push("/login");
      logout(this);
    },
    handleWorkspace() {
      window.open(`${this.$config.workspaceFEURL}`, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.header-auth {
  display: flex;

  .new-icon {
    background-color: $brightGreen;
    color: #fff;
    font-size: 9px;
    padding: 0 2px 0 2px;
    border-radius: 4px;
    line-height: 11px;

    &.parent {
      position: absolute;
      right: -21px;
      top: -3px;
    }

    &.menu-new {
      position: absolute;
      right: 5px;
      top: 1px;
    }
  }

  p {
    margin-left: 1.1rem;
    color: $text_gray;
    font-size: 1.3rem;
    text-transform: uppercase;
    font-weight: 600;
  }

  .tip {
    p {
      color: white;
      margin: 0;
      font-size: 1.4rem;
      text-transform: none;
      a {
        text-decoration: underline;
      }
    }
  }

  svg {
    width: 1.8rem;
    height: 1.8rem;

    path {
      transition: 0.3s ease-out;
    }
  }

  &__financial,
  &__title,
  &__logout,
  &__workspace {
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
      svg path {
        fill: $brightGreen;
      }
    }
  }

  &__financial,
  &__logout {
    margin: 0 0 0 3.6rem;
    border: 0;
    box-shadow: none;
    background: none;
    text-decoration: none;
  }

  &__workspace {
    margin: 0 0 0 3.6rem;
    border: 0;
    box-shadow: none;
    background: none;
    text-decoration: none;
    position: relative;
    .tip {
      top: 20px;
      &::after {
        display: none;
      }
    }
    .header-auth__disabled {
      cursor: not-allowed;
    }
  }



  &__reports {
    position: relative;
    margin-right: 3.6rem;
  }

  &__profile {
    position: relative;
    margin: 0 0 0 3.6rem;
  }

  &__mytools {
    position: relative;
    margin: 0 0 0 3.6rem;
  }

  &__dropdown {
    position: absolute;
    padding-top: 1.6rem;
    top: 100%;
    left: -5rem;
    z-index: 3;
    width: 16rem;

    &.reports {
      width: 36rem;
    }

    ul {
      padding: 1rem;
      background: $light_gray;
    }

    li {
      background: $light_gray;
      position: relative;
      &.not-subscribe {
        cursor: not-allowed;
        &:after {
          background: none;
        }
      }
    }

      &:after {
        content: "";
        position: absolute;
        width: 1.8rem;
        height: 1.8rem;
        background: $light_gray;
        display: block;
        transform: rotate(45deg);
        top: 0.6rem;
        left: 5rem;
      }


    a {
      font-size: 1.5rem;
      line-height: 3rem;
      color: $white;
      text-decoration: none;
      transition: 0.3s ease-out;

      &:hover {
        opacity: 0.7;
      }
    }
  }

  &__disabled {
    display: inline-block;
    height: 100%;
    &:hover {
      + .tip {
        display: block;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    & ~ .tooltip:hover {
        display: block;
        left: 50%;
        transform: translateX(-50%);
    }
  }
}
</style>
